import apiClient from '@/services/apiClient';

export default {
	namespaced: true,
	state: {
		lightspeed: null,
	},
	getters: {
		lightspeed(state) {
			return state.lightspeed;
		},
	},
	mutations: {
		SET_LIGHTSPEED(state, lightspeed) {
			state.lightspeed = lightspeed
		},
		CLEAR_STORE(state) {
			state.lightspeed = null;
		}
	},
	actions: {
		init({commit}) {
			return new Promise((resolve, reject) => {
				apiClient.get('modules/webshop/lightspeed/get').then(res => {
					commit('SET_LIGHTSPEED', res.data);
					resolve(res.data);
				}).catch(err => {
					reject(err);
				})
			});
		},
		refresh({commit}) {
			return new Promise((resolve, reject) => {
				apiClient.get('modules/webshop/lightspeed/get').then(res => {
					commit('SET_LIGHTSPEED', res.data);
					resolve(res.data);
				}).catch(err => {
					reject(err);
				})
			});
		},
		update({commit}, params) {
			return new Promise((resolve, reject) => {
				apiClient.put('modules/webshop/lightspeed/update', params).then(res => {
					commit('SET_LIGHTSPEED', res.data);
					resolve(res.data);
				}).catch(err => {
					reject(err);
				})
			});
		},
		checkPermissions({commit}) {
			return new Promise((resolve, reject) => {
				apiClient.get('modules/webshop/lightspeed/checkpermissions').then(res => {
					commit('SET_LIGHTSPEED', res.data);
					resolve(res.data);
				}).catch(err => {
					reject(err);
				})
			});
		},
		checkShopInfo({commit}) {
			return new Promise((resolve, reject) => {
				apiClient.get('modules/webshop/lightspeed/checkshopinfo').then(res => {
					commit('SET_LIGHTSPEED', res.data);
					resolve();
				}).catch(err => {
					reject(err);
				})
			});
		},
		activate({commit}) {
			return new Promise((resolve, reject) => {
				apiClient.get('modules/webshop/lightspeed/activate').then(res => {
					commit('SET_LIGHTSPEED', res.data);
					resolve();
				}).catch(err => {
					reject(err);
				})
			});
		},
		async clear({commit}) {
			commit('CLEAR_STORE');
		}
	}
}
